export class OpenModal {
    constructor(optionalOptions = {}) {
        this._modalButtons = document.querySelectorAll('.open-modal');

        if (!this._modalButtons) {
            this.destructor();
            return true;
        }

        let template
        let buttonTemplateAttr

        this._modalButtons.forEach((button) => {
            button.addEventListener("click", () => {
                buttonTemplateAttr = button.dataset.template

                if (!buttonTemplateAttr) {
                    return false
                }

                template = document.getElementById(buttonTemplateAttr);
                if (!template) {
                    return false
                }

                window.closeAllModals()

                template.classList.add('modal-opened')
            })
        })
    }

    destructor() {
        this._modalButtons = null;
    }
}

export default new OpenModal();
